import { Routes, Route, useLocation } from "react-router-dom";
import EnergyProfile from "./scenes/ems/profile";
import EnergyBenchmark from "./scenes/ems/benchmark";
import BaseloadScene from "./scenes/ems/baseload";
import MySpaceViewer from "./scenes/building";
import ArcsScene from "./scenes/arcs"; 
import MaintenanceScene from "./scenes/maintenance"; 
import Performancetrend from './scenes/ems/performancetrend';
import EnergyTempCurve from "./scenes/ems/energytempcurve";
import Login from "./scenes/login";
import Home from "./scenes/home";
import { CssBaseline, ThemeProvider } from "@mui/material";
import { ColorModeContext, useMode } from "./theme";
import { SiteProvider } from "./components/siteselector/SiteContext";
import {DateProvider}  from "./components/datepicker/DateContext";
import Layout from "./components/Layout";
import User from "./scenes/user/user";
import NotFound from './scenes/not-found/not-found';
import { YearProvider } from "./components/yearpicker/YearContext";
import TableData from "./scenes/tabledata";
import BuildingOverview from "./scenes/buildingoverview";
import BuildingHeatMap from "./scenes/3dViewHeatmap";
import IFrameBuildingView from "./scenes/iframeBuildingView";
import LiveTable from "./scenes/liveTable";
import SmplrSpaceComponentLocation from "./scenes/3dComponentLocation";

function App() {
  const [theme, colorMode] = useMode();
  //get the current location using react-router's useLocation hook
  const location = useLocation();
  const isLoginRoute = location.pathname === '/';

  return (
    <SiteProvider>
     <ColorModeContext.Provider value={colorMode}>
      <DateProvider>
       <ThemeProvider theme={theme}>
        {isLoginRoute ? null : <CssBaseline />}
            <Routes>
                <Route path="/" element={<Login />} />
                <Route path="/projects" element={<Layout showTop={false} element={<Home/>}/>}/>
                <Route path="/projects/:siteId" element={<Layout headerTitle='Beschikbare locaties' headerSubtitle='Kies een locatie' showTop={false} element={<Home/>}/>}/>
                <Route path="/projects/:siteId/buildingoverview" element={<Layout headerTitle='Gebouw overzicht' showTop={true} element={<BuildingOverview/>}/>}/>
                <Route path="/projects/:siteId/comfort/building" element={<Layout headerTitle='3D Weergave' element={<MySpaceViewer/>}/>}/>
                <Route path="/projects/:siteId/comfort/heatmapbuilding" element={<Layout headerTitle='3D Weergave heatmap' showTop={true} element={<BuildingHeatMap/>}/>}/>
                {/* Render table with pageRef */}
                <Route path="/projects/:siteId/comfort/liveTable/:pageName/:tablePageRef/:tableRefreshTime" element={<Layout element={<LiveTable/>}/>}/>
                <Route path="/projects/:siteId/comfort/table" element={<Layout headerTitle='Tabel Data' element={<TableData/>}/>}/>
                <Route path="/projects/:siteId/comfort/componentlocation" element={<Layout headerTitle='3D Weergave Component locatie' element={<SmplrSpaceComponentLocation/>}/>}/>
                <Route path="/projects/:siteId/ems/profile" element={<Layout headerTitle='Energieprofiel' headerSubtitle='Verken en ontdek' element={<EnergyProfile/>}/>}/>
                <Route path="/projects/:siteId/ems/benchmark" element={<Layout headerTitle='Benchmark' element={<YearProvider><EnergyBenchmark/></YearProvider>}/>}/>
                <Route path="/projects/:siteId/ems/baseload" element={<Layout headerTitle='Baseload' element={<BaseloadScene/>}/>}/> 
                <Route path="/projects/:siteId/ems/performancetrend" element={<Layout headerTitle='Prestatietrend' element={<Performancetrend/>}/>}/> 
                {/* Nieuw */}
                <Route path="/projects/:siteId/ems/energytempcurve" element={<Layout headerTitle='Energie vs buitentempratuur' element={<EnergyTempCurve/>}/>}/> 
                <Route path="/projects/:siteId/arcs" element={<Layout headerTitle='Arcs' headerSubtitle='Alle openstaande arcs van dit project' element={<ArcsScene/>}/>}/>
                <Route path="/projects/:siteId/maintenance" element={<Layout headerTitle='Onderhoudsmodule' element={<MaintenanceScene/>}/>}/>
                <Route path="/user/:siteId" element={<Layout showTop={false} headerTitle='Gebruiker' element={<User/>}/>}/>
                {/* IFRAME ROUTE */}
                <Route path="/3dbuildingviewer/:siteId/:key/:viewType/:renderMode" element={<IFrameBuildingView/>}/>
                <Route path='*' element={<NotFound/>} />
            </Routes>
          </ThemeProvider>  
        </DateProvider>
     </ColorModeContext.Provider>
    </SiteProvider>
  );
}

export default App;
